/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const moduleImporter = () => import('./DynamicAssistant');
const Server = () => (<></>);

export const DynamicMAA = (props) => {
  const moduleRef = useRef(null);
  const [_, forceRender] = useState();

  useEffect(() => {
    moduleImporter().then((module) => {
      moduleRef.current = module.DynamicAssistant;
      if (!moduleRef.current) {
        throw new Error(`Error importing Dynamic Assistant.`);
      }
      forceRender(new Date().getTime());
    });
  }, []);

  if (typeof window === 'undefined') return Server();

  if (!moduleRef.current) {
    return (
      <Skeleton>
        <SkeletonBlock aspect="wide" />
      </Skeleton>
    );
  }

  return (
    <moduleRef.current {...props} />
  );
};